module.exports = __webpack_public_path__ + "static/media/A TRIAL 2.232a78d2.mp3";